import { getcurrentUser, isMultiTinVal } from "./common.service";
import { checkIsInternal, checkIsSimulationMode, extendedTinLevelExperience } from "./createStorage";
import { StorageService } from "./storage.service";
import { getReimbursementLobPayload } from "@src/apps/Reimbursement/utils/reimbursementLobSelection";
const storageService = new StorageService;

export const handleError = (message: string, error: any): void => {
  console.error(`[Error] ${message}`, error);
};

export const ReturnMonthlyString = (months: string) => {
    let monthName: any;
    switch (months) {
      case '01':
        monthName = 'January';
        break;
      case '02':
        monthName = 'February';
        break;
      case '03':
        monthName = 'March';
        break;
      case '04':
        monthName = 'April';
        break;
      case '05':
        monthName = 'May';
        break;
      case '06':
        monthName = 'June';
        break;
      case '07':
        monthName = 'July';
        break;
      case '08':
        monthName = 'August';
        break;
      case '09':
        monthName = 'September';
        break;
      case '10':
        monthName = 'October';
        break;
      case '11':
        monthName = 'November';
        break;
      case '12':
        monthName = 'December';
        break;
      default:
        monthName = null;
    }
    return monthName != null ? monthName.substring(0, 3) : null;
  };

export const nFormatter = (formatNumber, scValue?) => {
  if (formatNumber >= 1000000000) {
    return (formatNumber / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B';
  }
  if (formatNumber >= 1000000) {
    return (formatNumber / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (formatNumber >= 1000) {
    return (formatNumber / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  if (formatNumber < 0 && scValue && formatNumber >= -999) {
    return parseFloat(formatNumber).toFixed(0).replace(/\.0$/, '');
  }
  if (formatNumber < 0 && scValue && formatNumber >= -999999) {
    return (formatNumber / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  if (formatNumber < 0 && scValue && formatNumber <= -1000000) {
    return (formatNumber / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (formatNumber < 1000 && scValue && formatNumber >= 0) {
    return parseFloat(formatNumber).toFixed(0).replace(/\.0$/, '');
  }
  if (formatNumber < 1000 && !scValue) {
    return parseFloat(formatNumber).toFixed(1).replace(/\.0$/, '');
  }
  return formatNumber;
}

export const nFormatterWithDollar = (formatNumber) => {
  if (formatNumber === null || formatNumber === undefined || formatNumber === '') {
    return '[$]';
  }
  if (formatNumber >= 1000000000) {
    return '$' + (formatNumber / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B';
  }
  if (formatNumber >= 1000000) {
    return '$' + (formatNumber / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (formatNumber >= 1000) {
    return '$' + (formatNumber / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  if (formatNumber < 1000) {
    return '$' + parseFloat(formatNumber).toFixed(1).replace(/\.0$/, '');
  }
  return '$' + formatNumber;
}

export const nondecimalFormatter = (fnumber) => {
  if (fnumber >= 1000000000) {
    return (fnumber / 1000000000).toFixed(0).replace(/\.0$/, '') + 'B';
  }
  if (fnumber >= 1000000) {
    return (fnumber / 1000000).toFixed(0).replace(/\.0$/, '') + 'M';
  }
  if (fnumber >= 1000) {
    return (fnumber / 1000).toFixed(0).replace(/\.0$/, '') + 'K';
  }
  if (fnumber < 1000) {
    return fnumber.toFixed(0).replace(/\.0$/, '');
  }
  if (fnumber < 0) {
    return fnumber.toFixed(0).replace(/\.0$/, '');
  }

  return fnumber;
}

export const decimalFormatter = (fnumber: number): string => {
  if (fnumber >= 1000000000) {
    return (fnumber / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B';
  }
  if (fnumber >= 1000000) {
    return (fnumber / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (fnumber >= 1000) {
    return (fnumber / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  if (fnumber < 1000 && fnumber >= 0) {
    return fnumber.toFixed(1).replace(/\.0$/, '');
  }
  if (fnumber < 0) {
    return fnumber.toFixed(1).replace(/\.0$/, '');
  }

  return fnumber.toString();
};

export const formatValueWithComma = (value: number): any => {
  try {
      if (isNaN(value)) {
          return value;
      }
      const formattedValue = Math.abs(value).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      return value < 0 ? `-${formattedValue}` : `${formattedValue}`;
  } catch (error) {
      return value;
  }
};

export const getAddedArrayofString = (value) => {
  let updatedName = ''
  value.map((sourceName, index) => {
    updatedName = index !== value.length - 1 ? `${updatedName + sourceName}, ` : updatedName + sourceName
  })
  return updatedName
}
export const returnZeroIfNoVal = (val: number | undefined) => {
  return isNaN(val) || !val || typeof val === 'undefined' ? 0 : val;
}
export const roundingValue = (value: number, decimalPlaces: number): string => {
  if (!value && value !== 0) {
    return "";
  }
  let output = value?.toFixed(decimalPlaces);
  const positiveZero = (0).toFixed(decimalPlaces);
  if (output === '-' + positiveZero) {
    output = positiveZero;
  }
  return output;
}
export const roundPercentage = (percentage) => {
  if (percentage == '<1') {
    return 1;
  } else if (percentage === '>99') {
    return 99;
  } else {
    return percentage;
  }
}

export const roundingPercentage = (value: any): string => {
  const num = Number(value);
  if (isNaN(num)) {
    return "0";
  }
  if (num > 0 && num < 1) {
    return '<1';
  } else if (num >= 100) {
    return '>99';
  } else {
    return num.toFixed(0);
  }
}
export const getTinId = () => {
  return sessionStorage.getItem('selectedTinId');
}



export const providerKeyData = () => {
  return getCurrentUserInfoBykey('ProviderKey');
}
export const getCurrentUserInfoBykey = (key) => {
    const currentUser = JSON.parse(getcurrentUser());
  return currentUser && currentUser[0] ? currentUser[0][key] : '';
}
export const getSpecificTinValue = (requestParam) => {
  let specificTin;
  if (requestParam?.length > 0 && requestParam[0].Tin !== 'All') {
    const taxArrayFormatted = [];
    for (const element of requestParam) {
      taxArrayFormatted.push(element?.Tin);
    }
    specificTin = taxArrayFormatted.join(',');
  } else {
    if (isMultiTinVal()) {
      specificTin = isAffData()?.tins;
    }
  }
  return specificTin;
}

const isAffData = () => {
  try {
    return JSON.parse(sessionStorage.getItem('aff'));
  } catch (err) {
    return false;
  }
}

const JAVA_DATE_MONTH_MAP: Record<string, string> = {
  Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06',
  Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12',
};

export const formatJavaDateToISO = (dateStr: string): string => {
  if (!dateStr) return '';
  // Format: "Sat Mar 01 00:00:00 GMT 2025"
  const parts = dateStr.trim().split(/\s+/);
  if (parts.length >= 6) {
    const month = JAVA_DATE_MONTH_MAP[parts[1]] || '01';
    const day = parts[2].padStart(2, '0');
    const year = parts[5];
    return `${month}/${day}/${year}`;
  }
  return dateStr;
};

export const getISODateRange = (periodStart: string, periodEnd: string): string => {
  const start = formatJavaDateToISO(periodStart);
  const end = formatJavaDateToISO(periodEnd);
  if (!start || !end) return '';
  return `${start} - ${end}`;
};

export const dateFormatterWithLeadingZero = (timeStamp: string): string => {
  if (!timeStamp) {
    return '';
  }
  let date1;
  if (timeStamp.includes('T')) {
    date1 = timeStamp.split('T'); // "2019-02-01T00:00:00.000+0000"
  } else {
    date1 = timeStamp.split(' '); // "2019-02-01 06:00:00"
  }
  const splitDate = date1[0].split('-'); // "2019-02-01"
  const newDate = [splitDate[1], splitDate[2], splitDate[0]].join('/'); // "02/01/2019"
  return newDate;
};

export const getDateRange = (periodStart: string | undefined, periodEnd: string | undefined): string => {
  if (!periodStart || !periodEnd) {
    return '';
  }

  const startDate = dateFormatterWithLeadingZero(periodStart);
  const endDate = dateFormatterWithLeadingZero(periodEnd);

  return `${startDate} - ${endDate}`;
};

export const getDateRangeISO = (periodStart: string | undefined, periodEnd: string | undefined): string => {
  if (!periodStart || !periodEnd) {
    return '';
  }

  const dateRange = getISODateRange(periodStart, periodEnd);
  return dateRange;
};

export const formatValue = (dy) => {
  if (typeof dy === 'number') {
    if (dy === 0) {
      return '0';
    } else if (dy < 999) {
      return dy.toFixed(0);
    } else if (dy < 999999) {
      return (dy / 1000).toFixed(1) + 'K';
    } else {
      return (dy / 1000000).toFixed(1) + 'M';
    }
  } else {
    return dy;
  }
};
export const getCompareLobs = (LOB) => {
  if (LOB === 'All') {
    return 'All';
  } else if (LOB === 'EI') {
    return 'E&I';
  } else if (LOB === 'CS') {
    return 'C&S';
  } else if (LOB === 'MR') {
    return 'M&R';
  } else if (LOB === 'DL') {
    return 'Dual';
  } else {
    return undefined;
  }
  // else if (LOB === 'UN') { uncomment when unknown is added
  //   return 'Unknown';
  // }
};

export const getRSMClaims = (claim) => {
  switch (claim) {
    case 'Facility':
      return 'UB';
    case 'Professional':
      return 'HCFA';
    default:
      return 'All';
  }
};

export const generateMonthVal = (shortMonth) => {
  if (shortMonth === '01') {
    return 'Jan';
  } else if (shortMonth === '02') {
    return 'Feb';
  } else if (shortMonth === '03') {
    return 'Mar';
  } else if (shortMonth === '04') {
    return 'Apr';
  } else if (shortMonth === '05') {
    return 'May';
  } else if (shortMonth === '06') {
    return 'Jun';
  } else if (shortMonth === '07') {
    return 'Jul';
  } else if (shortMonth === '08') {
    return 'Aug';
  } else if (shortMonth === '09') {
    return 'Sep';
  } else if (shortMonth === '10') {
    return 'Oct';
  } else if (shortMonth === '11') {
    return 'Nov';
  } else if (shortMonth === '12') {
    return 'Dec';
  } else {
    return null;
  }
};

export const getSMEdits = (edit) => {
  switch (edit) {
    case 'Return':
      return 'Return';
    case 'Documentation':
      return 'Documentation';
    case 'Reject':
      return 'Rejection';
    case 'Informational':
      return 'Informational';
    default:
      return 'All';
  }
};

export const getSMClaims = (claim) => {
  switch (claim) {
    case 'HCFA':
      return 'Professional';
    case 'UB':
      return 'Facility';
    default:
      return 'All';
  }
};

export const getSELob = (lob) => {
  switch (lob) {
    case 'M&R':
      return 'Medicare';
    case 'C&S':
      return 'Medicaid';
    case 'E&I':
      return 'Commercial';
    case 'DUAL':
      return 'Dual';
    case 'UNKNOWN':
      return 'Other';
    default:
      return 'All';
  }
};


export const getRSELob = (lob) => {
  switch (lob) {
    case 'Medicare':
      return 'M&R';
    case 'Medicaid':
      return 'C&S';
    case 'Commercial':
      return 'E&I';
    case 'Dual':
      return 'Dual';
    case 'Other':
      return 'Unknown';
    default:
      return 'All';
  }
}

export const getRSMEdits = (edit) => {
  switch (edit) {
    case 'Return':
      return 'Return';
    case 'Documentation':
      return 'Documentation';
    case 'Rejection':
      return 'Reject';
    case 'Informational':
      return 'Informational';
    default:
      return 'All';
  }
}

export const dateFormatter = (timeStamp: string): string => {
  if (!timeStamp) {
    return '';
  }
  let date1;
  if (timeStamp.includes('T')) {
    date1 = timeStamp.split('T'); // "2019-02-01T00:00:00.000+0000"
  } else {
    date1 = timeStamp.split(' '); // "2019-02-01 06:00:00"
  }
  const splitDate = date1[0].split('-'); // "2019-02-01"
  const newDate = [+splitDate[1], +splitDate[2], +splitDate[0]].join('/'); // "2/1/2019"
  return newDate;
}
export const addPlusbetweenstring = (str) => {
  const stringValue = str;

  const noSpecialCharacters = stringValue?.replace(/[^\w ]/g, ' +');

  return sentenceCase(noSpecialCharacters);
}

export const sentenceCase = (str: string) => {
  return str?.replace(/\w\S*/g, function (txt) {
    return txt?.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export const formatString = (string) => {
  const modifiedString = string?.trim().split(' ').join(', ');

  return modifiedString;
}

export const getMsadGroups = () => {
  let msad_groups;

  try {
    const msad_groups_string: any = sessionStorage.getItem('msad_groups');
    const msad_groups_val = msad_groups_string && atob(msad_groups_string);

    if (msad_groups_val) {
      msad_groups = JSON.parse(msad_groups_val);
    } else {
      // Handle the case when msad_groups_val is falsy
    }
  } catch (error) {
    // Handle the error
  }
  return msad_groups;
}

export const getRandomNumber = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const checkForNa = (val) => {
  return isNullOrUndefined(val) ? 'N/A' : val;
}
export const isNullOrUndefined = (value: any): boolean => {
  return value === null || value === undefined;
}
export const formatedNumber = (value) => {
  let formattedValue
  if (!isNaN(value)) {
    formattedValue = new Intl.NumberFormat('en-US').format(Math.round(value));
  } else {
    formattedValue = value;
  }
  return formattedValue;
}
export const getCMSDate = (startDate, endDate, timePeriodChange) => {
  if (!startDate || !endDate) {
    return;
  } else {
    if (timePeriodChange) {
      return (
        dateFormatterWithLeadingZero(startDate) +
        ' - ' +
        dateFormatterWithLeadingZero(endDate)
      );
    } else {
      return dateFormatter(startDate) + ' - ' + dateFormatter(endDate);
    }
  }
}

export const dateFormatterWithZero = (timeStamp: string): string => {
  if (!timeStamp) {
    return '';
  }
  const startTime = timeStamp.split('/');
  if (startTime[0].length < 2) {
    startTime[0] = '0' + startTime[0];
  }
  if (startTime[1].length < 2) {
    startTime[1] = '0' + startTime[1];
  }
  const newDate = [startTime[0], startTime[1], startTime[2]].join('/');
  return newDate;
}
export const getLobValue = (lob, mpin, key) => {
  const selectedLob = mpin.data.find((e: any) => e.lob === lob);
  if (key === 'Excluded') {
    return selectedLob ? 'Y' : 'N';
  } else if (key === 'Excl Eff Date') {
    return selectedLob ? selectedLob.exclusionStartDate : 'N/A';
  } else if (key === 'Excl Term Date') {
    return selectedLob ? selectedLob.exclusionEndDate : 'N/A';
  } else {
    return '';
  }
}


export const getTinValues = () => {
  const sessionState = JSON.parse(sessionStorage.getItem('state') || '').affTaxId;
  const isExtendedTinLevelExperienceTrue = extendedTinLevelExperience === 'true';
  let tinText = '';
  if (sessionState && sessionState?.Tin !== 'All') {
    if (Array.isArray(sessionState)) {
      sessionState.forEach((element) => {
        tinText += element.Tin + ',';
      });
      tinText = tinText.replace(/,$/, '');
    } else {
      // Handle the case where sessionState is not an array
      tinText = sessionState.Tin;
    }
  }
  if (checkIsInternal() && !checkIsSimulationMode() && isExtendedTinLevelExperienceTrue) {
    const serializedState = JSON.parse(sessionStorage.getItem('state') || '{}');
    let tins = '';
    if (serializedState.affTaxId[0].Tin === 'All') {
      tins = serializedState.affTaxId[0].Tin;
    } else if (
      serializedState.extendedCorporateTinSelected &&
      (serializedState.extendedCorporateTinSelected.Tin === 'All' ||
        serializedState.extendedCorporateTinSelected.Tin === 'All Selected TINs') ||
      (serializedState.extendedCorporateTinSelected.TINNAME === 'All' ||
        serializedState.extendedCorporateTinSelected.Tinname === 'All Selected TINs')
    ) {
      tins = 'Multiple';
    } else {
      tins = serializedState.extendedCorporateTinSelected.Tin;
    }
    tinText = tins;
  }
  return tinText;
}

export const numberWithCommas = (x) => {
  try {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } catch (Error) {
    return null;
  }
}
export const formatCurrency = (value) => {
  return value !== 'N/A' ? '$' + numberWithCommas(value) : 'N/A';
}

// Enhanced currency formatter with K suffix for VBC module
export const formatCurrencyWithKSuffix = (value: any) => {
  if (value != null && value !== '') {
    let numValue: number;

    if (typeof value === 'string') {
      // Handle K suffix (e.g., "3.39K" -> 3390)
      if (value.endsWith('K') || value.endsWith('k')) {
        numValue = parseFloat(value.slice(0, -1)) * 1000;
      } else {
        numValue = parseFloat(value);
      }
    } else {
      numValue = value;
    }

    if (!isNaN(numValue)) {
      // Format with K suffix for amounts >= 1000
      if (numValue >= 1000) {
        const kValue = numValue / 1000;
        // Format K values: round to 1 decimal place, remove trailing zeros
        const formatted = kValue.toFixed(1);
        const trimmed = formatted.replace(/\.0$/, '');
        return `$${trimmed}K`;
      } else {
        return `$${numValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      }
    }
  }
  return value || '';
}

// VBC-specific date formatter for MM/DD/YYYY format
export const formatVBCDate = (value: any) => {
  if (value) {
    try {
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      }
    } catch (error) {
      console.error('Error formatting VBC date:', error);
    }
  }
  return value || '';
}

// Get the initial calendar year for VBC filters
export const getInitialCalendarYear = (): string => {
  const now = new Date();
  const month = now.getMonth(); // 0-based
  const year = now.getFullYear();
  // January rollover logic for YTD label will be handled in generator utility; store raw year for now
  return year.toString();
}
export const formatPercentage = (value) => {
  return value !== 'N/A' ? roundingPercentage(Number(value)) + '%' : 'N/A';
}
export const getPrintData = (exportTableData) => {
  const DATA: Array<any> = [];
  exportTableData.forEach((element) => {
    DATA.push({
      TIN: element.Tin,
      MPIN: element.Mpin,
      'Hospital Name': element.Hospital,
      'Total OP Drug Spend (Allowed)': element.drugSpend,
      'Total OP Drug CMS Index': element.UnitCostOpp,
      'SRD Opportunity at 165%': numberWithCommas(element.percentofCMSAllowance) + '%',
      'Impact (Total Sourcing Savings Opportunity)': element.Impact,
      'Actual Savings (Total)': element.TotalActualSavings,
      'Actual Savings (FI)': element.FIValues,
      'Actual Savings (ASO)': element.asoValues,
      Status: element.status,
      'Allowance Range': element.allowanceRange,
      'Expired/Expiring': element.expiryDays < 0 || element.expiryDays !== null ? 'Y' : 'N'
    });
  });
  return DATA;
}

export const calculatePadding = (TAB_OPTION, selectedTab, searchOption, isMessage) => {
  if (TAB_OPTION[0]?.key === selectedTab?.key || !searchOption?.length) {
    return '0';
  }

  const getPadding = (index: number) => searchOption[index]?.isEnabled ? 43 : 0;

  const [firstOptionPadding, lastOptionPadding, secondLastOptionPadding] = [
    getPadding(0),
    getPadding(searchOption?.length - 1),
    searchOption?.length > 1 ? getPadding(searchOption?.length - 2) : 0,
  ];

  const messagePadding = isMessage ? 43 : 0;

  return `${firstOptionPadding}px 0px ${lastOptionPadding + secondLastOptionPadding + messagePadding}px`;
};

export const formatDate = (date: string): string => {
  if (!date) return '';
  const parts = date.split('/');
  return [parts[2], parts[0], parts[1]].join('/');
}

export const formatDateWithDash = (date: string): string => {
  if (!date) return '';
  const parts = date.split('-');
  return [parts[1], parts[2], parts[0]].join('/');
}




type TimePeriodResult = {
  timeFilter: string | null;
  timeFilterText: string | null;
};

export const formatDateRange = (value: string): string => {
  // Case 1: Already formatted like "2025/01/01-2025/05/30"
  const isoFormatMatch = value.match(/^\d{4}\/\d{2}\/\d{2}-\d{4}\/\d{2}\/\d{2}$/);
  if (isoFormatMatch) {
    const dateRange = value.split('-');
    const part1 = dateRange[0].split('/');
    const part2 = dateRange[1].split('/');

    return `${[part1[1], part1[2], part1[0]].join('/')} - ${[part2[1], part2[2], part2[0]].join('/')}`;
  }
  return value

}

export const parseSelectedTimePeriod = (value: string): TimePeriodResult => {
  // Case 1: Already formatted like "2025/01/01-2025/05/30"
  const isoFormatMatch = value.match(/^\d{4}\/\d{2}\/\d{2}-\d{4}\/\d{2}\/\d{2}$/);
  if (isoFormatMatch) {
    return {
      timeFilter: "DatesSplit",
      timeFilterText: value
    };
  }

  // Case 2: Labeled format like "Mar YTD (01/01/2025 - 03/31/2025)"
  const match = value.match(/(\d{2}\/\d{2}\/\d{4})\s*-\s*(\d{2}\/\d{2}\/\d{4})/);
  if (!match) {
    // Fallback: treat as plain year
    return {
      timeFilter: "CalendarYear",
      timeFilterText: value
    };
  }

  const [_, start, end] = match;
  const startDate = new Date(start);
  const adjustedEndDate = new Date(end);
  adjustedEndDate.setMonth(3); // April
  adjustedEndDate.setDate(30);

  const format = (date: Date) =>
    `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;

  return {
    timeFilter: "DatesSplit",
    timeFilterText: `${format(startDate)}-${format(adjustedEndDate)}`
  };
};



export const getFinancialOwners = (dataItem) => {
  return dataItem?.FinancialOwner?.includes('|') ? dataItem?.FinancialOwner?.split('|') : [dataItem?.FinancialOwner]
}

export const isValidUrl = (url: string) => {
  try {
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
}



export const getFullYearRange = (input: string | null): string => {
  if (!input) return '';
  // Check if input is already a date range
  if (input.includes('/')) {
    return input; // Already in date range format
  }
// Otherwise, assume it's a year and build the full year range
  const year = parseInt(input);
  return `01/01/${year}-12/31/${year}`;
}

//graph data
export const getQuarterAndYear = (date: Date) =>{
  const month = date.getMonth();

  if (month >= 0 && month <= 2) {
    return 'Q1 ' + date.getFullYear();
  } else if (month >= 3 && month <= 5) {
    return 'Q2 ' + date.getFullYear();
  } else if (month >= 6 && month <= 8) {
    return 'Q3 ' + date.getFullYear();
  } else {
    return 'Q4 ' + date.getFullYear();
  }
}
export const getQuarterAndYearString = (date: Date) =>{
  const month = date.getMonth();


  if (month >= 0 && month <= 2) {
    return '(Q1 ' + date.getFullYear() + ')';
  } else if (month >= 3 && month <= 5) {
    return '(Q2 ' + date.getFullYear() + ')';
  } else if (month >= 6 && month <= 8) {
    return '(Q3 ' + date.getFullYear() + ')';
  } else {
    return '(Q4 ' + date.getFullYear() + ')';
  }
}
export const  getPaymentIntegrityDates = () =>{
  const currentYear = new Date().getFullYear();
  const arr:any = [];
  const yearsPI = [currentYear, currentYear - 1, currentYear - 2, currentYear - 3];
  const janYearsPI = [currentYear - 1, currentYear - 2, currentYear - 3, currentYear - 4];
  const dataToMap = new Date().getMonth() === 0 ? janYearsPI : yearsPI;
  dataToMap.forEach((year) => {
    arr.push({
      name: year === currentYear ? createYtd(year) : year.toString(),
      value: createYtdValue(year),
      disable: false
    });
  });
  return arr;
}
export const createYtdValue = (year) =>{
  const firstDayOfYear = new Date(year, 0, 1);
  const getLastDayOfYear =
    new Date().getFullYear() !== year
      ? new Date(year, 12, 0)
      : new Date(new Date().getFullYear(), new Date().getMonth(), 0);
  return `${getFormattedDate(firstDayOfYear)}-${getFormattedDate(getLastDayOfYear)}`;
}
function getFormattedDate(date) {
  const year = date.getFullYear();
  const month = (1 + date.getMonth())
    .toString()
    .padStart(2, '0')
    .replace(/(^|-)+/g, '$1');
  const day = date
    .getDate()
    .toString()
    .padStart(2, '0')
    .replace(/(^|-)+/g, '$1');
  return month + '/' + day + '/' + year;
}
function createYtd(year) {
  const firstDayOfYear = new Date(year, 0, 1);
  const getLastDayOfYear =
    new Date().getFullYear() !== year
      ? new Date(year, 12, 0)
      : new Date(new Date().getFullYear(), new Date().getMonth(), 0);
  return `${getLastDayOfYear.toLocaleString('default', { month: 'short' })} YTD (${getFormattedDate(
    firstDayOfYear
  )} - ${getFormattedDate(getLastDayOfYear)})`;
}

export const  nFormatter2 = (fnumber) => {
  if (fnumber >= 1000000000) {
    return (fnumber / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B';
  }
  if (fnumber >= 1000000) {
    return (fnumber / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (fnumber >= 1000) {
    return (fnumber / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  if (fnumber < 1 && fnumber !== 0) {
    const pos = Math.abs(Math.floor(Math.log10(fnumber)));
    return fnumber.toFixed(pos).replace(/\.0$/, '');
  }
  if (fnumber < 1000) {
    return parseFloat(fnumber).toFixed(1).replace(/\.0$/, '');
  }
  return fnumber;
}
export const convertDateFormat = (dateString: string): string => {
    if (dateString.includes('-') && dateString.match(/\d{2}\/\d{2}\/\d{4}-\d{2}\/\d{2}\/\d{4}/)) {
        const [startDate, endDate] = dateString.split('-');

        const convertSingleDate = (date: string): string => {
            const [month, day, year] = date.split('/');
            return `${year}/${month}/${day}`;
        };

        return `${convertSingleDate(startDate)}-${convertSingleDate(endDate)}`;
    }
    return dateString;
};

export const getPiSelectedGeoFilters = () => {
  const parseSessionValue = (raw: string | null) => {
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      return raw;
    }
  };

  const toGeoString = (value: any, join = false, separator = ","): any => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    if (Array.isArray(value)) {
      const vals = value
        .map((v: any) => (typeof v === 'string' ? v : (v?.value || v?.name || '')))
        .filter((v: string) => !!v && v !== 'All');

      if (vals.length === 0) return '';
      return join ? vals.join(separator) : vals[0];
    }
    if (typeof value === 'object') {
      return value?.value || value?.name || '';
    }
    return '';
  };

  const selectedRegion = parseSessionValue(sessionStorage.getItem('PI_GEO_SELECTED_REGION'));
  const selectedStates = parseSessionValue(sessionStorage.getItem('PI_GEO_SELECTED_STATES'));
  const selectedMarket = parseSessionValue(sessionStorage.getItem('PI_GEO_SELECTED_MARKET'));

  return {
    resolvedRegion: toGeoString(selectedRegion),
    resolvedState: toGeoString(selectedStates, true),
    resolvedMarket: toGeoString(selectedMarket, true, '|'),
  };
};
// Helper to convert state names/abbreviations to comma-separated abbreviation string
function getStateAbbreviationString(input: string | string[], usStates: { name: string, abbreviation: string }[]): string {
  if (!input) return '';
  let stateArr: string[] = [];
  if (Array.isArray(input)) {
    stateArr = input;
  } else if (typeof input === 'string') {
    stateArr = input.split(',').map(s => s.trim());
  }
  return stateArr
    .map(name => {
      const upper = name.toUpperCase();
      const found = usStates.find(
        s => s.name.toUpperCase() === upper || s.abbreviation.toUpperCase() === upper
      );
      return found ? found.abbreviation : name;
    })
    .join(',');
}
export const returnParamsValuesforPI = (parameters) => {

  const piRawValue = sessionStorage.getItem('piTimePeriod');
  let piTimePeriodName = '';
  if (piRawValue) {
      const parsed = JSON.parse(piRawValue);
      piTimePeriodName = parsed?.name || '';
  }

  parameters['piTimePeriod'] = parameters["piTimePeriod"] || piTimePeriodName || parameters["timePeriod"] || '';

    let timePeiod;
    let timeFilter;

    if (parameters.piTimePeriod && parameters.piTimePeriod.includes('YTD')) {
      const timeFormat:any = returnYtdValue(parameters.piTimePeriod);
      timePeiod =
        dateFormat(timeFormat.split('-')[0].trim()) + '-' + dateFormat(timeFormat.split('-')[1].trim());
      timeFilter = 'DatesSplit';
    } else {
      timePeiod = parameters.piTimePeriod;
      timeFilter = 'CalendarYear';
    }
    const contractIds = Array.isArray(parameters.ContractIds)
      ? parameters.ContractIds
      : Array.isArray(parameters.contractIds)
        ? parameters.contractIds
        : [];
    const validContractIds = contractIds
      .filter((contractId) => typeof contractId === 'string' && contractId.trim() !== '');
    const hasContractIds = validContractIds.length > 0;
    const params = {};
    params['TimeFilter'] = timeFilter;
    params['TimeFilterText'] = timePeiod;
    if (!hasContractIds && isMultiTinVal()) {
      if (parameters.taxId && parameters.taxId !== '' && parameters.taxId !== 'All') {
        params['Tin'] = parameters.taxId;
      } else {
        // getMultiTins() only returns TINs when multiple TINs are selected (checkMultiTin).
        // For single TIN flow, fall back to multiSelectedTins directly.
        const multiTins = getMultiTins();
        params['Tin'] = multiTins || sessionStorage.getItem('multiSelectedTins') || '';
      }
    } else if (!hasContractIds) {
      const currentUser: any = getcurrentUser2();
      const providerkey = currentUser[0].ProviderKey;
      params['ProviderSysKey'] = providerkey;
      if (parameters.taxId && parameters.taxId !== '' && parameters.taxId !== 'All') {
        params['Tin'] = parameters.taxId;
      }
    }
    // Honour pre-resolved Tin passed directly in parameters (e.g. from print preview)
    // Skip if value is "All" — geo flow uses Region/State/Market instead
    if (!hasContractIds && parameters.Tin && parameters.Tin !== 'All' && !params['Tin'] && (!parameters.taxId || parameters?.taxId[0]?.Tin !== 'All')) {
      params['Tin'] = parameters.Tin;
    }
    if (parameters.lineOfBusiness && parameters.lineOfBusiness !== '' && parameters.lineOfBusiness !== 'All') {
      params['Lob'] = parameters.lineOfBusiness
        .split(',')
        .map((lob) => returnLob(lob))
        .map((lob) => lob === 'Individual Exchange' ? 'Individual exchange' : lob)
        .join(',');
    }
    if (parameters.claimsFilter && parameters.claimsFilter !== '' && parameters.claimsFilter !== 'All') {
      params['ClaimType'] = returnClaimType(parameters.claimsFilter);
    }
    const piServiceType = sessionStorage.getItem('piServiceType');
    if (piServiceType && piServiceType !== 'undefined') {
      const serType = JSON.parse(piServiceType);
      params['ServiceType'] = serType.name;
    }
    const piVendors = sessionStorage.getItem('piVendors');
    if (piVendors && piVendors !== 'undefined') {
      const vendors = JSON.parse(piVendors);
      if (Array.isArray(vendors) && vendors.length > 0) {
        params['Vendor'] = vendors.map(vendor => vendor.name || vendor).join(',');
      }
    }
    // Add region, state, and market from parameters only for geo segmentation (when no ProviderSysKey and no Tin)
    if (!hasContractIds && !params['ProviderSysKey'] && !params['Tin']) {
      const { resolvedRegion, resolvedState, resolvedMarket } = getPiSelectedGeoFilters();

      const normalizeRegion = (r: string) => r ? r.charAt(0).toUpperCase() + r.slice(1).toLowerCase() : r;
      if (resolvedRegion) {
        params['Region'] = normalizeRegion(resolvedRegion);
      } else if (parameters.Region && parameters.Region !== '') {
        params['Region'] = normalizeRegion(parameters.Region);
      } else if (parameters.region && parameters.region !== '') {
        params['Region'] = normalizeRegion(parameters.region);
      }
      // Convert state names to abbreviations using usStates
      if(resolvedState) {
        params['State'] = resolvedState;
      } else if (parameters.State && parameters.State !== '') {
        params['State'] = parameters.State;
      } else if (Array.isArray(parameters.states) && parameters.states.length > 0) {
        params['State'] = parameters.states.join(',');
      }

      // Only add Market if parameters.Market is a non-empty string or parameters.market is a non-empty array
      if (resolvedMarket) {
        params['Market'] = resolvedMarket;
      } else if (typeof parameters.Market === 'string' && parameters.Market !== '') {
        params['Market'] = parameters.Market;
      } else if (Array.isArray(parameters.market) && parameters.market.length > 0) {
        params['Market'] = parameters.market.join('|');
      }
    }

    if (validContractIds.length > 0) {
      params['ContractIds'] = validContractIds;
    }

    setPiChildPageData(parameters, piServiceType);
    return params;
  }
export const returnParamsValuesV2 = (parameters) => {
    let timePeiod;
    let timeFilter;
    if (parameters.timePeriod && parameters.timePeriod.includes('YTD')) {
      const timeFormat:any = returnYtdValue(parameters.timePeriod);
      timePeiod =
        dateFormat(timeFormat.split('-')[0].trim()) + '-' + dateFormat(timeFormat.split('-')[1].trim());
      timeFilter = 'DatesSplit';
    } else {
      timePeiod = parameters.timePeriod;
      timeFilter = 'CalendarYear';
    }
    const params = {};
    params['TimeFilter'] = timeFilter;
    params['TimeFilterText'] = timePeiod;
    if (isMultiTinVal()) {
      if (parameters.taxId && parameters.taxId !== '') {
        params['Tin'] = parameters.taxId;
      } else {
        params['Tin'] = getMultiTins();
      }
    } else {
      const currentUser: any = getcurrentUser2();
      const providerkey = currentUser[0].ProviderKey;
      params['ProviderSysKey'] = providerkey;
      if (parameters.taxId && parameters.taxId !== '') {
        params['Tin'] = parameters.taxId;
      }
    }
    if (parameters.lineOfBusiness && parameters.lineOfBusiness !== '') {
      const lobVal = returnLob(parameters.lineOfBusiness);
      params['Lob'] = lobVal === 'Individual Exchange' ? 'Individual exchange' : lobVal;
    }
    if (parameters.claimsFilter && parameters.claimsFilter !== '') {
      params['ClaimType'] = returnClaimType(parameters.claimsFilter);
    }
    const piServiceType = sessionStorage.getItem('piServiceType');
    if (piServiceType && piServiceType !== 'undefined') {
      const serType = JSON.parse(piServiceType);
      params['ServiceType'] = serType.name;
    }
    const piVendors = sessionStorage.getItem('piVendors');
    if (piVendors && piVendors !== 'undefined') {
      const vendors = JSON.parse(piVendors);
      if (Array.isArray(vendors) && vendors.length > 0) {
        params['Vendor'] = vendors.map(vendor => vendor.name || vendor).join(',');
      }
    }

    // Add region, state, and market from parameters only for geo segmentation (when no ProviderSysKey and no Tin)
    if (!params['ProviderSysKey'] && !params['Tin']) {
      if (parameters.Region && parameters.Region !== '') {
        params['Region'] = parameters.Region;
      } else if (parameters.region && parameters.region !== '') {
        if(parameters.region === 'NATIONAL'){
          params['Region'] = 'National';
        } else {
          params['Region'] = parameters.region;
        }

      }
      // Convert state names to abbreviations using usStates
      if (parameters.State && parameters.State !== '') {
        params['State'] = parameters.State;
      } else if (Array.isArray(parameters.states) && parameters.states.length > 0) {
        params['State'] = parameters.states.join(',');
      }

      // Only add Market if parameters.Market is a non-empty string or parameters.market is a non-empty array
      if (typeof parameters.Market === 'string' && parameters.Market !== '') {
        params['Market'] = parameters.Market;
      } else if (Array.isArray(parameters.market) && parameters.market.length > 0) {
        params['Market'] = parameters.market.join('|');
      }
    }

    setPiChildPageData(parameters, piServiceType);
    return params;
  }
  const setPiChildPageData = (parameters, piServiceType) => {
    const globalFilterData = {
      claimType: 'All',
      serviceType: 'All',
      vendor: 'All'
    }
    if (parameters.claimsFilter && parameters.claimsFilter !== '') {
      globalFilterData.claimType = returnClaimType(parameters.claimsFilter);
    }
    if (piServiceType && piServiceType !== 'undefined') {
      const serType = JSON.parse(piServiceType);
      globalFilterData.serviceType = serType.name;
    }
    const piVendors = sessionStorage.getItem('piVendors');
    if (piVendors && piVendors !== 'undefined') {
      const vendors = JSON.parse(piVendors);
      if (Array.isArray(vendors) && vendors.length > 0) {
        globalFilterData.vendor = vendors.map(vendor => vendor.name || vendor).join(',');
      }
    }
    sessionStorage.setItem('reactState', JSON.stringify(globalFilterData));
  }
export const returnParamsValues = (parameters) => {
  let timePeiod;
  let timeFilter;
  if (parameters.timePeriod && parameters.timePeriod.includes('YTD')) {
    const timeFormat:any = returnYtdValue(parameters.timePeriod);
    timePeiod =
      dateFormat(timeFormat.split('-')[0].trim()) + '-' + dateFormat(timeFormat.split('-')[1].trim());
    timeFilter = 'DatesSplit';
  } else {
    timePeiod = parameters.timePeriod;
    timeFilter = 'CalendarYear';
  }
  const params = {};
  params['TimeFilter'] = timeFilter;
  params['TimeFilterText'] = timePeiod;
  if (isMultiTinVal()) {
    params['Tin'] = getMultiTins();
  } else {
    const currentUser: any =  getcurrentUser2();
    const providerkey = 959;
    params['ProviderSysKey'] = providerkey;
    if (parameters.taxId && parameters.taxId !== '') {
      params['Tin'] = parameters.taxId;
    }
  }
  if (parameters.lineOfBusiness && parameters.lineOfBusiness !== '') {
    const lobVal = matchLobWithLobData(parameters.lineOfBusiness);
    params['Lob'] = lobVal === 'Individual Exchange' ? 'Individual exchange' : lobVal;
  }
  return params;
}
const getcurrentUser2 = () =>{
  try {
    if (sessionStorage.getItem('currentUser')) {
      return JSON.parse(sessionStorage.getItem('currentUser') || '');
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
}
function returnClaimType(claim) {
  if (claim === 'PROFESSIONAL') {
    return 'Professional';
  } else if (claim === 'INSTITUTIONAL') {
    return 'Facility';
  } else {
    return claim;
  }
}
function returnYtdValue(timePeriod) {
  const regex = /\(([^)]+)\)/;
  const match = regex.exec(timePeriod);
  if (match && match.length > 1) {
    return match[1];
  }
}
function retuenTimePeiod(timePeriod) {
  if (timePeriod && timePeriod.length > 5) {
    return timePeriod;
  } else {
    return createYtdValue(timePeriod);
  }
}
function returnFormattedValue(value, prefix?: string) {
  let formattedValue;
  const text = nFormatter2(value);
  if (prefix) {
    formattedValue = prefix + text;
  } else {
    formattedValue = text;
  }
  return formattedValue;
}
function returnPercentageValue(value, prefix?: string) {
  let formattedValue;
  const text = Number(value);
  if (prefix) {
    formattedValue = text.toFixed(0).toString() + prefix;
  } else {
    formattedValue = text.toFixed(0).toString();
  }
  return formattedValue;
}
function returnLob(lob) {
  const normalizedLob = typeof lob === 'string' ? lob.trim() : lob;
  const lobMappings = {
    EI: 'E&I',
    'E&I': 'E&I',
    Commercial: 'E&I',
    CS: 'C&S',
    'C&S': 'C&S',
    Medicaid: 'C&S',
    MR: 'M&R',
    'M&R': 'M&R',
    Medicare: 'M&R',
    EXC: 'Individual Exchange',
    'Individual Exchange': 'Individual Exchange',
    'Individual exchange': 'Individual Exchange',
  };

  return typeof normalizedLob === 'string'
    ? lobMappings[normalizedLob] || normalizedLob
    : normalizedLob;
}

interface ILobNames {
  all: string;
  eAndICommerCial: string;
  mAndRMedicare: string;
  cAndSMedicaid: string;
  unCategorized: string;
  exchange?: string;
  dual: string;
  unknown: string;
}
export const lobName: ILobNames = {
  all: 'All',
  eAndICommerCial: 'Commercial',
  mAndRMedicare: 'Medicare',
  cAndSMedicaid: 'Medicaid',
  unCategorized: 'Uncategorized',
  exchange: 'Individual Exchange',
  dual: 'Dual',
  unknown: 'Unknown'
};

const lobMap: { [key: string]: string } = {
  "EI": "COMMERCIAL",
  "DL": "DUAL",
  "CS": "MEDICAID",
  "MR": "MEDICARE"
};
const lobMapping: { [key: string]: string } = {
  'EI': 'E&I',
  'MR': 'M&R',
  'CS': 'C&S',
  'DL': 'Dual'
};

const claimParamMap = {
  PROFESSIONAL: 'HCFA',
  INSTITUTIONAL: 'UB',
};

const  matchLobWithLobData = (lob) => {
  if (lob === lobName.all) {
    return 'All';
  } else if (lob === lobName.eAndICommerCial) {
    return 'E&I';
  } else if (lob === lobName.mAndRMedicare) {
    return 'M&R';
  } else if (lob === lobName.cAndSMedicaid) {
    return 'C&S';
  } else if (lob === lobName.exchange) {
    return 'Individual Exchange';
  } else {
    return undefined;
  }
}
function getMultiTins() {
  if (isMultiTinVal()) {
    return sessionStorage.getItem('multiSelectedTins');
  } else {
    return '';
  }
}
function dateFormat(timeStamp: string): string {
  if (!timeStamp) {
    return '';
  }
  const date1 = timeStamp.split('/');
  const newDate = [date1[2], date1[0], date1[1]].join('/');
  return newDate;
}
export const getItemsByType = (type,items, Digitalitems, WorkforceManagementitems) => {
  switch (type) {
    case 'Provider Operations':
      return items;
    case 'Digital':
      return Digitalitems;
    case 'Workforce Management':
      return WorkforceManagementitems;
    default:
      return [];
  }
};
export const isTypeActive = (type,allPrograms,activeProviderOperations,activeDigital,activeWorkforceManagement) => {
  return (
    allPrograms ||
    (type === 'Provider Operations' && activeProviderOperations) ||
    (type === 'Digital' && activeDigital) ||
    (type === 'Workforce Management' && activeWorkforceManagement)
  );
};

/**
 * Returns a comma-separated string of TINs from a payload's taxId array, sorted descending.
 * If the first TIN value is "All" (case-insensitive), returns an empty string.
 */
export function getCommaSeparatedSortedTins(payload: any): string {
  if(payload?.extendedCorporateTinSelected?.Tin && payload?.extendedCorporateTinSelected?.Tin !== "All Selected TINs"){
    return payload?.extendedCorporateTinSelected?.Tin;
  }
  const tinValues = (payload.taxId || []).map((item: any) => item.Tin);
  if (tinValues.length > 0 && typeof tinValues[0] === 'string' && tinValues[0].toLowerCase() === 'all') {
    return '';
  }
  return tinValues.sort((a, b) => b.localeCompare(a)).join(',');
}
export function getPcmsTin(storedPayload: any): string | null {
  if(storedPayload?.extendedCorporateTinSelected?.Tin && storedPayload?.extendedCorporateTinSelected?.Tin !== "All Selected TINs"){
    return storedPayload?.extendedCorporateTinSelected?.Tin;
  }
  const tinValues = storedPayload?.topFilterTin?.Tin;
  if (!tinValues || tinValues === "All") {
    const multiTIn = sessionStorage.getItem('multiSelectedTins');
    return multiTIn ? multiTIn : "";
  }
  return tinValues;
}

/**
 * Maps adjustmentValues to their corresponding label.
 */
export function getAdjustmentLabel(value: string): string {
  switch (value) {
    case "ALL":
      return "ALL";
    case "1":
      return "FIRST";
    case "2":
      return "SECOND";
    case "3":
      return "THIRD";
    case "4":
      return "FINAL";
    default:
      return value || "ALL";
  }
}

export const getOverTurnCountVal = (appealsReasonData: any[]): number => {
  let overturnCountTotal = 0;
  for (let y = 0; y < (appealsReasonData?.length || 0); y++) {
    if (y === 0) {
      overturnCountTotal = appealsReasonData[y].Count;
    } else {
      overturnCountTotal = overturnCountTotal + appealsReasonData[y].Count;
    }
  }
  return overturnCountTotal;
};

export function flattenClaimProducts(productTypeArr: any[]): string[] | string {
  if (!Array.isArray(productTypeArr) || productTypeArr.length === 0) return "";
  if (
    productTypeArr[0] &&
    typeof productTypeArr[0].ClaimSystem === "string" &&
    productTypeArr[0].ClaimSystem.trim().toUpperCase() === "ALL"
  ) {
    return "";
  }
  const result = productTypeArr.reduce((acc: string[], curr: any) => {
    if (Array.isArray(curr.ClaimProducts)) {
      acc.push(...curr.ClaimProducts);
    }
    return acc;
  }, []);
  return result.length === 0 ? "" : result;
}

export function extractPlatformValues(platformTypeArr: any[]): string[] | string {
  if (!Array.isArray(platformTypeArr) || platformTypeArr.length === 0) return "";
  // If first item's name or value is "All" (case-insensitive), return ""
  const first = platformTypeArr[0];
  if (
    (typeof first?.name === "string" && first.name.trim().toUpperCase() === "ALL") ||
    (typeof first?.value === "string" && first.value.trim().toUpperCase() === "ALL")
  ) {
    return "";
  }
  const values = platformTypeArr.map(item => item.name).filter(Boolean);
  return values.length === 0 ? "" : values;
}

export function removeSierraFromClaimSystems(claimSystems: any): any {
  if (!Array.isArray(claimSystems)) {
    return claimSystems;
  }

  return claimSystems.filter(
    (system: any) => typeof system !== "string" || system.toLowerCase() !== "sierra"
  );
}

/**
 * Returns true if the value is a string and equals "ALL" (case-insensitive).
 */
export function isAllString(val: any): boolean {
  return typeof val === "string" && val.trim().toUpperCase() === "ALL";
}

export const getLineOfBusinessValue = (storedPayload: any): string | null => {
  if (Object.prototype.hasOwnProperty.call(storedPayload || {}, 'lineOfBusinessMultiSelect')) {
    return getReimbursementLobPayload(storedPayload.lineOfBusinessMultiSelect) || '';
  }

  const lineOfBusiness = storedPayload?.lineOfBusiness;
  return isAllString(lineOfBusiness) ? "" : lineOfBusiness;
};

export const getLineOfBusinessServiceInteraction = (storedPayload: any): string | null => {
  const lineOfBusiness = storedPayload?.lineOfBusiness;
  return isAllString(lineOfBusiness) ? "" : lobMap[lineOfBusiness] || lineOfBusiness;
};

export const getLineOfBusinessOvertimeServiceInteraction = (storedPayload: any): string | null => {
  const lineOfBusiness = storedPayload?.lineOfBusiness;
  return lineOfBusiness === "All" ? "" : lobMapping[lineOfBusiness] || lineOfBusiness;
};

export const getPcmsLineOfBusiness = (storedPayload: any): string | null => {
  const lineOfBusiness = storedPayload?.lineOfBusiness || storedPayload?.dplineOfBusiness;
  return lineOfBusiness === "All" ? "" : lineOfBusiness;
};

const joinMeaningfulNpis = (npis: unknown[]): string =>
  npis
    .map((npi) => (typeof npi === 'string' ? npi.trim() : ''))
    .filter((npi) => npi && npi !== 'All')
    .join(',');

// PCMS keeps its applied Provider selection in `state.provider`; the NPI keys are legacy fallbacks.
export const getNpi = (storedPayload: any): string | null => {
  if (typeof storedPayload?.provider === 'string') {
    const provider = joinMeaningfulNpis(storedPayload.provider.split(','));
    if (provider) return provider;
  }
  if (Array.isArray(storedPayload?.topFilterNpiMultiSelect)) {
    const npis = joinMeaningfulNpis(
      storedPayload.topFilterNpiMultiSelect.map((item: { Npi?: unknown } | null) => item?.Npi)
    );
    if (npis) return npis;
  }
  const npi = storedPayload?.topFilterNpi?.Npi;
  return npi === "All" ? "" : npi;
};

export const getPcmsTimeFilterText = (storedPayload: any): string | null => {
  const timeFilterText = storedPayload?.topFilterTimePeriod?.FilterText;

  if (!timeFilterText) return null;

  // Check if timeFilterText includes "YTD" or is only a 4-digit year
  if (timeFilterText.includes("YTD") || /^\d{4}$/.test(timeFilterText)) {
    return "YTD";
  }

  return "startandendDates";
};
export const getPcmsTimeFilter = (storedPayload: any): string | null => {
    const startDate = storedPayload?.topFilterTimePeriod?.StartDate;
    const endDate = storedPayload?.topFilterTimePeriod?.EndDate;

    if (startDate === "All" && endDate === "All") {
        const newTimePeriodPcms = sessionStorage.getItem('newTimePeriodPcms');
        if (newTimePeriodPcms) {
            const match = newTimePeriodPcms.match(/(\d{2}\/\d{2}\/\d{4})\s*-\s*(\d{2}\/\d{2}\/\d{4})/);
            if (match) {
                const [_, start, end] = match;
                // Convert MM/DD/YYYY to YYYY-MM-DD
                const convertToISO = (dateStr: string): string => {
                    const [month, day, year] = dateStr.split('/');
                    return `${year}-${month}-${day}`;
                };
                return `${convertToISO(start)},${convertToISO(end)}`;
            }
        }
        return null;
    }

    if (!startDate || !endDate) return null;

    // Convert date objects to YYYY-MM-DD format
    const formatDate = (dateStr: string): string => {
        return dateStr.split('T')[0];
    };

    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);

    return `${formattedStartDate},${formattedEndDate}`;
};

/**
 * Formats date range for year-based filter
 * @param topFilterTimePeriod - Object containing FilterText, StartDate, and EndDate
 * @returns Formatted date range string (MM/DD/YYYY-MM/DD/YYYY) or empty string
 */
export const formatYearDateRange = (topFilterTimePeriod: any): string => {
  if (!topFilterTimePeriod || topFilterTimePeriod?.FilterText?.length !== 4) {
    return '';
  }

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const startDate = formatDate(topFilterTimePeriod.StartDate);
  const endDate = formatDate(topFilterTimePeriod.EndDate);

  return `${startDate}-${endDate}`;
};

export const getSpeciality = (storedPayload: any): string | null => {
  const topFilterSpeciality = storedPayload?.topFilterSpeciality?.Speciality;
  return topFilterSpeciality === "All" ? "" : topFilterSpeciality;
};

export const getClaimTypeServiceInteraction = (storedPayload: any): string | null => {
  const claimType = storedPayload?.claimsFilter;
  return claimType === "All" ? "" : claimParamMap[claimType] || claimType;
};

export const numberFormatting = (nStr: any): string => {
  nStr += '';
  const x = nStr.split('.');
  let x1 = x[0];
  const x2 = x.length > 1 ? '.' + x[1] : '';
  const rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }
  return x1 + x2;
}

export const encryptSensitiveData = (data: string): string => {
  if (!data) return '';
  return 'ENC:' + btoa(data);
};

export const decryptSensitiveData = (encryptedData: string): string => {
  if (!encryptedData || !encryptedData.startsWith('ENC:')) return encryptedData;

  try {
    return atob(encryptedData.substring(4));
  } catch (error) {
    console.error('Error decrypting data:', error);
    return '';
  }
};

export const handlePasteKnownCharacters = (e, onChange) => {
  e.preventDefault();
  const pastedText = e.clipboardData.getData('text') || '';

  // Clean the text - include \n and \r for newlines
  const cleanedText = pastedText.replace(/[^a-zA-Z0-9\s\-_+=\[\]{}|\\:;'"<>,.\?\/!@#$%\^&*()`~•\n\r]/g, '');

  // Get current input value
  const currentValue = e.currentTarget.value || '';
  const selectionStart = e.currentTarget.selectionStart || 0;
  const selectionEnd = e.currentTarget.selectionEnd || 0;

  // Create new value with cleaned pasted text inserted
  const newValue =
    currentValue.substring(0, selectionStart) +
    cleanedText +
    currentValue.substring(selectionEnd);

  // Update input value and trigger onChange event
  const syntheticEvent = {
    target: {
      value: newValue,
      name: e.currentTarget.name || e.currentTarget.getAttribute('name') || ''
    }
  };
  onChange && onChange(syntheticEvent);
};

export const isValueFalse = (val: any): boolean => {
  return (
    val === '0' ||
    val === '0%' ||
    val === 0 ||
    val === 'false' ||
    val === false ||
    val === null ||
    val === undefined ||
    val === '0%' ||
    val === 'NaN' ||
    val === '' ||
    val === '0.0%' ||
    val === '0.00%' ||
    val === '0.0' ||
    val === '$0'

  );
};

export const isAllValuesFalse = (data: any): boolean => {
  if (!data || typeof data !== 'object') return false;
  return data.every((item: any) => isValueFalse(item?.value));
}

export const getBottomDateFromSession = (): string => {
  const date = sessionStorage.getItem('state');
  const storedDate = date ? JSON.parse(date) : {};

  const filterText = storedDate?.topFilterTimePeriod?.FilterText;

  // Check if FilterText is "All"
  if (filterText === "All") {
    const newTimePeriodPcms = sessionStorage.getItem('newTimePeriodPcms');
    return newTimePeriodPcms || "";
  }

  // Check if it's a year (length === 4)
  if (filterText?.length === 4) {
    return formatYearDateRange(storedDate?.topFilterTimePeriod);
  }

  // Return the FilterText or empty string
  return filterText || "";
};
